import { injectable, inject } from 'inversify-props';
import { IStatisticsApi, IStatisticsApiId } from '@/features/statistics/IStatisticsApi';
import { IStatisticsService } from './IStatisticsService';
import type { MpcStatisticsByDayLineDepartureRow } from './MpcStatisticsByDayLineDepartureRow';

@injectable()
export default class MpcStatisticsService implements IStatisticsService {
    @inject(IStatisticsApiId)
    api!: IStatisticsApi;

    async getMpcStatistics(calendarDay?: string): Promise<any[]> {
        try {
            return await this.api.getMpcStatistics(calendarDay);
        } catch {
            return [];
        }
    }

    async getMpcStatisticsByDayLineDeparture(from: string, to: string): Promise<MpcStatisticsByDayLineDepartureRow[]> {
        const response = await this.api.getMpcStatisticsByDayLineDeparture(from, to);
        return response?.data?.rows ?? [];
    }

    getExportUrl(from: string, to: string): string {
        return this.api.getExportUrl(from, to);
    }
}
